module.exports = __webpack_public_path__ + "img/2_adidas.24037d5c.jpg";